export default __webpack_public_path__ + "d50dff2e3b4bcaf393001610d16ac113.svg";